var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    staticClass: "sv2",
    attrs: {
      "visual": '자료실'
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "board-container"
  }, [!_vm._reference ? _c('board-list', _vm._b({
    attrs: {
      "writeScope": ['console']
    }
  }, 'board-list', _vm.boardProps, false)) : _vm.isWrite ? _c('board-input', _vm._b({}, 'board-input', _vm.boardProps, false)) : _c('board-view', _vm._b({
    attrs: {
      "_id": _vm._reference
    }
  }, 'board-view', _vm.boardProps, false))], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }